module.exports = __webpack_public_path__ + "4.png?9e24616a4e12e97ca4681c96cc202a44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/4.png
// module id = 50
// module chunks = 0